import { lazy } from 'react';

// Lazy load all screen components
export const Home = lazy(() => import('../../screens/Home'));
export const BookStore = lazy(() => import('../../screens/BookStore'));
export const Faqs = lazy(() => import('../../screens/Faqs'));
export const ContactUs = lazy(() => import('../../screens/ContactUs'));
export const PrivacyPolicies = lazy(() => import('../../screens/PrivacyPolicies'));
export const TermsAndConditions = lazy(() => import('../../screens/TermsAndConditions'));
export const ShoppingCart = lazy(() => import('../../screens/ShoppingCart'));
export const BookDetails = lazy(() => import('../../screens/BookDetails'));
export const Profile = lazy(() => import('../../screens/Profile'));
export const Purchases = lazy(() => import('../../screens/Purchases'));
export const Reports = lazy(() => import('../../screens/Reports'));
export const Support = lazy(() => import('../../screens/Support'));
export const Checkout = lazy(() => import('../../screens/Checkout'));
export const PaymentComplete = lazy(() => import('../../screens/PaymentComplete'));
export const Book = lazy(() => import('../../screens/Book')); 